import { Component } from '@angular/core';
import { AuthService } from '../../shared/auth.service';

@Component({
    template: ``
})
export class CallbackComponent {

    constructor(private authService: AuthService) {
        this.authService.handleAuth();
    }
}



// WEBPACK FOOTER //
// ./Client/app/components/callback/callback.component.ts